import { useCallback, useEffect, useState, createRef } from 'react'
import { useEffectOnce } from 'usehooks-ts'
import styled from 'styled-components'
import headerImage from './images/header.jpg'
import headerImageWide from './images/header-wide.jpg'
import Authors from 'components/Authors'

const Header = ({
  tenant,
  colorMode,
  title,
  lead,
}: {
  tenant?: object
  colorMode?: string
  title: string
  lead: string
}) => {
  const [hasHeader, setHasHeader] = useState(false)
  const [isMobile, setIsMobile] = useState(false)
  const [isWide, setIsWide] = useState(false)

  const handleResize = (): void => {
    setIsMobile(window.innerWidth < 711)
    setIsWide(
      window.innerWidth >= 1360 || window.innerWidth > window.innerHeight
    )
  }

  useEffectOnce(() => {
    const headerElement = document.querySelector('[class*=FullHeader_root]')
    if (headerElement) {
      setHasHeader(true)
    }
    // set height when window is resized
    handleResize()
    window.addEventListener('resize', handleResize)
    return () => {
      window.removeEventListener('resize', handleResize)
    }
  })

  return (
    <HeaderWrapper>
      <TopWrapper>
        <div className='header-image'>
          <img src={isWide ? headerImageWide : headerImage} alt='header' />
        </div>
        <div className='title-wrapper'>
          <div className='titles'>
            <h1 dangerouslySetInnerHTML={{ __html: title }}></h1>
            <h2>{lead}</h2>
          </div>
        </div>
      </TopWrapper>

      <div className='authors'>
        <Authors
          authors={[
            { name: 'Marius Aschwanden', unityID: '82372634' },
            { name: 'Christoph Hämmann', unityID: '31000657' },
            { name: 'Regina Schneeberger', unityID: '70622505' },
            { name: 'Mirjam Comtesse', unityID: '31549207' },
            { name: 'Brigitte Walser', unityID: '83886617' },
            { name: 'Simone Klemenz', unityID: '91815035' },
            { name: 'Bernhard Ott', unityID: '16288215' },
            { name: 'Cedric Fröhlich', unityID: '63919784' },
            { name: 'Quentin Schlapbach', unityID: '43055742' },
            { name: 'Mathias Lutz', unityID: '95724327' },
          ]}
          tenant={
            tenant
              ? tenant
              : {
                  key: 'bernerzeitung',
                  name: 'Berner Zeitung',
                  domain: 'bernerzeitung',
                  feedId: 3,
                  lang: 'de',
                }
          }
        />

        <div className='publication'>Publiziert am 23. September 2023</div>
      </div>
    </HeaderWrapper>
  )
}

const HeaderWrapper = styled.div`
  .publication {
    font-size: 1.2rem;
    color: var(--gray-3);
    margin-bottom: 60px;
    text-align: center;
    z-index: 10;
    position: relative;
  }
`

const TopWrapper = styled.div`
  background-color: transparent;
  overflow: hidden;
  position: relative;

  .header-image {
    background-color: #474b45;
    position: relative;
    width: 100%;
    height: 70vh;
    @media only screen and (max-width: 711px) {
      height: 75vh;
    }
    min-height: 450px;
    @media (orientation: landscape) {
      min-height: 600px;
    }
    object-fit: cover;
    img,
    div {
      width: 100%;
      height: 100%;
      position: absolute;
      object-fit: cover;
      overflow: visible;
      z-index: 1;
    }
  }

  .title-wrapper {
    z-index: 2;
    width: 668px;
    @media only screen and (max-width: 711px) {
      max-width: 80%;
    }
    position: absolute;
    top: 50%;
    left: 50%;
    @media only screen and (min-width: 0) {
      transform: translate(-50%, -100%);
    }
    @media only screen and (min-width: 768px) {
      transform: translate(-50%, -95%);
    }
    @media only screen and (min-width: 1200px) {
      transform: translate(-50%, -85%);
    }
    .titles {
      width: 100%;
      z-index: 99;
      top: 10vh;
      position: relative;
      @media only screen and (max-width: 711px) {
        top: 30vh;
      }
      @media (orientation: landscape) and (max-height: 1000px) {
        top: 18vh;
      }
      h1 {
        position: relative;
        margin: 0 auto;
        font-family: 'Suez One', serif;
        font-weight: 100;
        color: #fff;
        text-align: center;
        line-height: 0.6em;
        text-shadow: 1px 1px 15px #000, 1px 1px 15px #000;
        @media only screen and (min-width: 0px) {
          font-size: 4rem;
          line-height: 4.5rem;
          _color: red;
        }
        @media only screen and (min-width: 375px) {
          font-size: 4.5rem;
          line-height: 5rem;
          _color: red;
        }
        @media only screen and (min-width: 768px) {
          font-size: 7rem;
          line-height: 8rem;
          _color: yellow;
        }
        @media only screen and (min-width: 1200px) {
          font-size: 9rem;
          line-height: 10rem;
          _color: orange;
          text-shadow: 1px 1px 40px #000, 1px 1px 40px #000;
        }
        @media (orientation: landscape) and (max-height: 1000px) {
          _color: green;
          font-size: 7rem;
          line-height: 8rem;
        }
      }
      h2 {
        position: relative;
        left: -3.5%; // weird correction
        font-family: var(--font-sans-serif);
        color: #fff;
        padding: 1rem;
        font-weight: 300;
        font-size: 2.4rem;
        width: 100%;
        text-align: center;
        line-height: 1.3em;
        text-shadow: 1px 1px 8px #000, 1px 1px 8px #000;
        @media only screen and (max-width: 711px) {
          padding-top: 7vh;
          font-size: 2.2rem;
        }
      }
    }
  }
`

export default Header
